import * as React from 'react';
import { useDrawerHashNavigation, Link } from '@grandvisionhq/common';

const DRAWER_HASH = 'prescription';
const PrescriptionFormLabelDetailsTrigger = ({ title , onClick  })=>{
    useDrawerHashNavigation({
        drawerHash: DRAWER_HASH
    });
    return /*#__PURE__*/ React.createElement(Link, {
        href: `#${DRAWER_HASH}`,
        label: title,
        onClick: onClick
    });
};

export { PrescriptionFormLabelDetailsTrigger };
//# sourceMappingURL=PrescriptionFormLabelDetailsTrigger.js.map
